// extracted by mini-css-extract-plugin
module.exports = {"left":"_3htUA","center":"_3aeeb","right":"u8-my","onImage":"_2Q_Ci","offImage":"_31se6"};